<!--
  What a single pull request's row leads with, as two cells of the row's
  grid: GitHub's glyph for its state, then where it is (the repository, in
  the column a stack's title bar names its repository in) with its number
  under it. Read aloud it is a sentence of its own before the title:
  "Open, your turn, checks failing. acme/web #12".
-->
<script lang="ts">
  import { type PrKind } from '../logic/prKind';
  import PrState from './PrState.svelte';
  import RepoMark from './RepoMark.svelte';

  interface Props {
    kind: PrKind;
    /** Its review state and checks, in words, for a screen reader ("your turn, checks failing"). */
    words: string;
    /** `owner/name`. */
    repo: string;
    /** The owner's avatar. */
    avatarUrl: string | null | undefined;
    number: number;
    /** Why the App not being installed on the repository matters, when it is known not to be; null otherwise. */
    uncovered?: string | null;
  }
  let { kind, words, repo, avatarUrl, number, uncovered = null }: Props = $props();
</script>

<span class="pr-lead"><PrState {kind} /><span class="sr-only">, {words}. </span></span>
<div class="pr-where">
  <RepoMark {repo} {avatarUrl} />
  <span class="pr-where-sub"
    ><span class="pr-number mono">#{number}</span>{#if uncovered}<span class="pill pending app-missing" title={uncovered}
        >app not installed<span class="sr-only">: writes and live updates won't work in {repo}</span></span
      >{/if}</span
  >
</div>
